(() => {
  'use strict';
  const sources = new Map();
  const motion = () => document.body.classList.contains('animations-enabled') && !matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sourceFor = dialog => {
    if (sources.has(dialog)) return sources.get(dialog);
    const source = {
      dialog, opener: null, timer: null, openSequence: 0,
      get isConnected() { return dialog.isConnected; },
      contains(target) { return dialog.contains(target); },
      closeForHeader() { return this.close(false); },
      close(restore = true, immediate = false) {
        this.openSequence++;
        window.OleaHeaderPanels?.cancel(this);
        clearTimeout(this.timer);
        if (!dialog.open) { window.OleaHeaderPanels?.release(this); this.opener?.setAttribute('aria-expanded', 'false'); return window.OleaOverlayMotion.finished(dialog); }
        const finish = () => {
          dialog.classList.remove('is-closing');
          window.OleaHeaderPanels?.release(this);
          this.opener?.setAttribute('aria-expanded', 'false');
          if (restore && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        };
        return window.OleaOverlayMotion.hide(dialog, { immediate, after: finish });
      }
    };
    dialog.addEventListener('cancel', event => { event.preventDefault(); source.close(); });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-mobile-sheet-close]')) { source.close(); return; }
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) source.close();
    });
    dialog.addEventListener('close', () => {
      if (dialog.open || window.OleaHeaderPanels?.isPending(source)) return;
      clearTimeout(source.timer);
      dialog.classList.remove('is-closing');
      window.OleaHeaderPanels?.release(source);
      source.opener?.setAttribute('aria-expanded', 'false');
    });
    sources.set(dialog, source);
    return source;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mobile-sheet-open],.header-country');
    if (!button) return;
    if (button.matches('.header-country') && !matchMedia('(max-width:989px)').matches) return;
    const dialog = button.dataset.mobileSheetOpen ? document.getElementById(button.dataset.mobileSheetOpen) : document.querySelector('dialog.footer-localization-sheet');
    if (!(dialog instanceof HTMLDialogElement)) return;
    event.preventDefault();
    const source = sourceFor(dialog);
    if (dialog.open || window.OleaHeaderPanels?.isPending(source)) { source.close(); return; }
    clearTimeout(source.timer);
    source.opener = button;
    const sequence = ++source.openSequence;
    const reveal = () => {
      if (!dialog.isConnected || sequence !== source.openSequence) return false;
      dialog.classList.remove('is-closing');
      window.OleaOverlayMotion.show(dialog);
      button.setAttribute('aria-expanded', 'true');
      dialog.querySelector('[data-mobile-sheet-close]')?.focus({ preventScroll: true });
      return true;
    };
    if (window.OleaHeaderPanels) void window.OleaHeaderPanels.open('mobile-sheet', source, reveal);
    else reveal();
  });
  document.addEventListener('olea:header-panel-open', event => {
    sources.forEach(source => { if (event.detail.source !== source) source.close(false, true); });
  });
  document.addEventListener('olea:header-panel-close', event => {
    sources.forEach(source => source.close(event.detail?.restoreFocus !== false));
  });
  matchMedia('(min-width:990px)').addEventListener('change', () => sources.forEach(source => source.close(false, true)));
  const removals = new MutationObserver(records => {
    if (!records.some(record => record.removedNodes.length)) return;
    sources.forEach((source, dialog) => {
      if (dialog.isConnected) return;
      source.close(false, true);
      sources.delete(dialog);
    });
  });
  removals.observe(document.documentElement, { childList: true, subtree: true });
  // Only hide the native localization fallback after its replacement is wired.
  document.documentElement.classList.add('mobile-sheets-ready');
})();
